import { FC } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import { EmptyCartProps } from '../types';

const EmptyCart: FC<EmptyCartProps> = ({ emptyStateDescription, ...props }) => {
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });

  return (
    <div className="mt-28 min-h-[306px]">
      <p>
        {emptyStateDescription ??
          formatCartMessage({ id: 'cart.empty.ask', defaultMessage: 'Your shopping cart is empty' })}
      </p>
      {/* <ul className="mt-48 flex flex-col items-center gap-y-20 pb-8 lg:items-start">
        {categories
          .filter((category) => category.depth === 0)
          .map((category) => (
            <li key={category.name}>
              <Link link={category._url}>
                <Button
                  className="w-200 rounded-md border border-primary-black text-16 text-secondary-black"
                  variant="secondary"
                >
                  {category.name}
                </Button>
              </Link>
            </li>
          ))}
      </ul> */}
    </div>
  );
};

export default EmptyCart;
